import React from "react";

export const Milestones = () => (
  <div>
    <h2>Milestones: here are your milestones</h2>
  </div>
  );

export default Milestones;
